import React, { FC, ReactNode, useEffect, useState } from "react";
import { Input, Button, Row, Col, Checkbox, Select, Slider } from "antd";
import _ from "lodash";
import "antd/dist/antd.css";
import { QuestionaireType } from "../../../constants/enums";
import * as currencyCodes from "currency-codes";
import RenderFields from "../../../common/RenderQuestionFields";
import { SurveyTypes } from "../../../constants/constants";


const AddCadQuestionModal: FC<{
  headerTitle: string;
  handleCancel: any;
  onCreate?: any;
  data: any;
  isEditQuestion: boolean;
  maxLimit: number;
}> = ({
  headerTitle,
  handleCancel,
  onCreate,
  data,
  isEditQuestion,
  maxLimit,
}) => {
  const [item, setItem] = useState<any>(
    isEditQuestion
      ? data
      : {
          name: "",
          label: "",
          type: QuestionaireType.ThreeButton,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 6,
        }
  );

  const [errorText, setErrorText] = useState<string>("");
  const [activeType, setActiveType] = useState<string | undefined>(
    isEditQuestion ? data?.type : QuestionaireType.ThreeButton
  );
  const [choiceCount, setChoiceCount] = useState<number>(1);
  const [currencyCodeList, setcurrencyCodeList] = useState<any[]>();
  useEffect(() => {
    const currencies = currencyCodes.codes().map((code: string) => {
      return { label: code, value: code };
    });
    setcurrencyCodeList(currencies);
  }, []);

  useEffect(() => {
    if (isEditQuestion) {
      setActiveType(data.type);
      setItem(data);
      if (data.type === QuestionaireType.MultipleChoice) {
        setChoiceCount(data.options.length);
      }
    }
  }, []);

  const onAdd = () => {
    onCreate(item);
  };

  return (
    <div>
      <Row className="mb-4">
        <Row className="mb-1 d-flex justify-content-center">
          <Col>
            <h4>{headerTitle}</h4>
          </Col>
        </Row>
      </Row>
      <Row className="d-flex">
        {SurveyTypes.map((sType, idx) => (
          <Col span={sType.span} key={idx} className="mb-3">
            <Button
              className={`beam-btn w-full ${
                activeType === sType.label ? "green-btn cover" : ""
              }`}
              onClick={() => {
                setActiveType(sType.label);
                setItem({
                  ...item,
                  type: sType.label,
                });
              }}
            >
              {sType.label}
            </Button>
          </Col>
        ))}
      </Row>
      <Row className="mt-4 mb-4">
        <span className="col-label">Select Size:</span>
        <Slider
          className="w-100"
          defaultValue={item.ColSize}
          max={maxLimit}
          onChange={(value) => {
            setItem({
              ...item,
              ColSize: value,
            });
          }}
        />
      </Row>
      <Row className="mt-4 mb-4">
        <Col span={24}>
          <Input
            value={item.name}
            placeholder="Type Question name here..."
            onChange={(e) => {
              setItem({
                ...item,
                name: e.target.value,
              });
            }}
          />
          {errorText && (
            <span className="error-text">Please fill this field</span>
          )}
        </Col>
      </Row>
      <Row className="mt-4 mb-4">
        <Col span={24}>
          <Input
            value={item.label}
            placeholder="Type Question here..."
            onChange={(e) => {
              setItem({
                ...item,
                label: e.target.value,
              });
            }}
          />
          {errorText && (
            <span className="error-text">Please fill this field</span>
          )}
        </Col>
      </Row>
      <RenderFields
        item={item}
        setItem={setItem}
        choiceCount={choiceCount}
        setChoiceCount={setChoiceCount}
        activeType={activeType}
        currencyCodeList={currencyCodeList}
      />

      <Row className="action-grp mt-4">
        <Col span={8} className="pr-2">
          <Button
            className="beam-btn green-btn cover w-full"
            onClick={onAdd}
            disabled={maxLimit === 0}
          >
            {isEditQuestion ? "Edit" : "Add"}
          </Button>
        </Col>
        <Col span={8} className="pl-2">
          <Button
            className="beam-btn orange-btn bordered w-full"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default AddCadQuestionModal;
